import { Skeleton } from '@sib/ui';

interface EntityCommentCardSkeletonProps {
  hasBadge?: boolean;
}

export const EntityCommentCardSkeleton = ({
  hasBadge,
}: EntityCommentCardSkeletonProps) => (
  <div className="border-border bg-surface-subtle rounded-md border">
    <div className="flex items-center justify-between gap-3 px-4 py-3">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <Skeleton className="size-8 shrink-0 rounded-full" />
        <Skeleton className="h-5 w-28" />
        {hasBadge && <Skeleton className="h-5 w-24 rounded-sm" />}
      </div>
      <Skeleton className="h-5 w-36 shrink-0" />
    </div>

    <div className="border-border flex flex-col gap-2 border-t px-4 py-3">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  </div>
);
